(() => {
	const getTrafficSearchParams = new URLSearchParams(window.location.search);

	function getTrafficSource() {
		const referrer = document.referrer;

		if (getTrafficSearchParams.has("utm_source")) {
			return getTrafficSearchParams.get("utm_source");
		}

		// Check referrer for known search engines
		if (referrer.includes("google.")) {
			return "google";
		} else if (referrer.includes("bing.")) {
			return "bing";
		} else if (referrer.includes("yahoo.")) {
			return "yahoo";
		} else if (referrer.includes("duckduckgo.")) {
			return "duckduckgo";
		} else if (referrer.includes("baidu.")) {
			return "baidu";
		} else if (referrer.includes("yandex.")) {
			return "yandex";
		} else if (referrer.includes("ask.")) {
			return "ask";
		} else if (referrer.includes("search.aol.")) {
			return "aol";
		} else if (referrer.includes("search.naver.")) {
			return "naver";
		} else if (referrer.includes("search.seznam.cz")) {
			return "seznam";
		} else if (referrer.includes("ecosia.org")) {
			return "ecosia";
		} else if (referrer.includes("startpage.")) {
			return "startpage";
		} else if (referrer.includes("qwant.")) {
			return "qwant";
		} else if (referrer.includes("swisscows.")) {
			return "swisscows";
		} else if (referrer.includes("search.brave.")) {
			return "brave";
		}

		if (referrer === "") {
			return "direct";
		}

		return "other";
	}

	if (
		document.referrer &&
		!getTrafficSearchParams.has("utm_source") &&
		!getTrafficSearchParams.has("utm_medium")
	) {
		const source = getTrafficSource();
		getTrafficSearchParams.set("utm_source", source);
		getTrafficSearchParams.set("utm_medium", "organic");
		window.location.search = getTrafficSearchParams.toString();
	}
})();
